import React from "react";
import "./footer.css";
import { routes } from "../../javascript/routes";
import deesLogo from "../../img/dees.jpg"; // adjust the path if needed

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section logo-section">
          <img src={deesLogo} alt="Logo Dees" className="footer-img-logo" />
          <h2 className="footer-logo">Keramiekmeteenknipoog</h2>
          <p className="footer-description">
            Unieke keramiekstukken met een vleugje humor. Handgemaakt met
            liefde.
          </p>
        </div>

        <div className="footer-section navigation-section">
          <nav className="footer-nav">
            {routes.map(({ title, href }) => (
              <a key={title} href={href} className="footer-link">
                {title}
              </a>
            ))}
          </nav>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Contact</h3>
          <p>
            Email:{" "}
            <a href="mailto:deesgardeniers@hotmail.com">
              deesgardeniers@hotmail.com
            </a>
          </p>
          Telefoon: <a href="tel:+31612345678">+31 6 53888195</a>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Volg ons</h3>
          <div className="social-icons">
            <a href="#" aria-label="Facebook">
              📘
            </a>
            <a
              href="https://www.pinterest.com/deesje58/handmade-by-me/"
              aria-label="pintrests"
            >
              📸
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Keramiekmeteenknipoog. Alle rechten
          voorbehouden.
        </p>
      </div>
    </footer>
  );
}
